import apiService from './apiService';

/**
 * Service pour les variantes de produits normaux (vente en gros)
 */
class NormalProductVariantService {
  /**
   * Récupère la liste des variantes avec filtres
   * @param {Object} params - Paramètres de recherche
   */
  async getVariants(params = {}) {
    const response = await apiService.get('/normal-product-variants', params);
    return response.data;
  }

  /**
   * Récupère une variante spécifique
   * @param {string} id - ID de la variante
   */
  async getVariant(id) {
    const response = await apiService.get(`/normal-product-variants/${id}`);
    return response.data;
  }

  /**
   * Crée une nouvelle variante
   * @param {Object} variantData - Données de la variante
   */
  async createVariant(variantData) {
    const response = await apiService.post('/normal-product-variants', variantData);
    return response.data;
  }

  /**
   * Met à jour une variante
   * @param {string} id - ID de la variante
   * @param {Object} variantData - Nouvelles données
   */
  async updateVariant(id, variantData) {
    const response = await apiService.put(`/normal-product-variants/${id}`, variantData);
    return response.data;
  }

  /**
   * Supprime une variante
   * @param {string} id - ID de la variante
   */
  async deleteVariant(id) {
    return apiService.delete(`/normal-product-variants/${id}`);
  }
}

const normalProductVariantServiceInstance = new NormalProductVariantService();
export default normalProductVariantServiceInstance;
